import { defineType } from 'sanity';

export const imageGallery = defineType({
    name: 'imageGallery',
    title: 'Image Gallery section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'images',
            title: 'Gallery Images',
            type: 'array',
            of: [
                {
                    type: 'seoOptimizedImageUrl',
                },
            ],
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Image Gallery: ${title['en'] || title['sr']}`,
            };
        },
    },
});
